import { IFirstHandReport } from 'api/resort/types';
import { ILightboxImage, Lightbox } from 'components/common/Lightbox';
import React, {
  useCallback, useMemo, useRef, useState,
} from 'react';
import { formatAgoTimestampOrString } from 'util/formatAgo';
import classNames from 'classnames';
import { ReadMore } from 'components/common/ReadMore';
import { Diagnostics } from 'util/diagnostics';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import styles from './styles.module.scss';

export const Report = ({
  report, className,
}: {
  report: IFirstHandReport,
  className?: string,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);

  const images: Array<ILightboxImage> = useMemo(() => [{
    title: `${report.name}`,
    alt: `${report.translated || report.name}`,
    src: report.largeImage || report.image || '',
  }], []);

  const [lightBoxIndex, setLightBoxOpen] = useState<boolean>(false);

  const closeLightBox = useCallback(() => {
    setLightBoxOpen(false);
  }, [setLightBoxOpen]);

  const openLightBox = useCallback(() => {
    setLightBoxOpen(true);
  }, [setLightBoxOpen]);

  if (!(report.translated) && !(report.image)) {
    Diagnostics.error({ message: 'Report has no image and translated body', tag: 'First Hand Report', data: report });
    return null;
  }

  return (
    <>
      <div className={classNames(styles.wrapper, className)} ref={ref}>
        <div className={styles.box}>
          {/* eslint-disable-next-line */}
          {report.image && isVisible && <img src={report.image} className={styles.image} onClick={openLightBox} alt='' />}

          {/* { report.name && (
          <div className={styles.head}>
            <span className={classNames('h3', styles.h3)}>{report.name}</span>
          </div>
          )} */}

          { report.translated && <ReadMore text={report.translated} length={300} buttonClass={styles.btnReadMore} /> }

          <div className={styles.date}>
            {formatAgoTimestampOrString(report.date)}
          </div>
        </div>
      </div>
      {lightBoxIndex
    && <Lightbox onClose={closeLightBox} images={images} index={0} />}
    </>
  );
};
